export class Segment {
  private id: string;
  private projectName: string;
  private createdAt: Date;
  private modifiedAt: Date;
  private isIntegrationsActive: boolean;
  private leadType: string;
  private pipelineId: number;
  private statusId: number;
  private cityId: number;
  private entityId: number;
  private jkId: number;
  private tag: string;
  private utmSource: string;
  private isExportToTzActive: boolean;
  private firstComment: string;
  private secondComment: string;
  private depth: number;
  private triggersMinCount: number;
  private alphaNames: string[];
  private domainsList: string[];
  private phones: string[];
  private geoRegion: string[];
  private minAge: number;
  private maxAge: number;
  private limits: number;
  private autoType: number;
  private leadsCount?: number;

  constructor(
    id: string,
    projectName: string,
    createdAt: Date,
    modifiedAt: Date,
    isIntegrationsActive: boolean,
    leadType: string,
    pipelineId: number,
    statusId: number,
    cityId: number,
    entityId: number,
    tag: string,
    utmSource: string,
    isExportToTzActive: boolean,
    firstComment: string,
    secondComment: string,
    depth: number,
    triggersMinCount: number,
    minAge: number,
    maxAge: number,
    limits: number,
    alphaNames: string[],
    domainsList: string[],
    phones: string[],
    autoType: number,
    jkId: number,
    geoRegion: string[]
  ) {
    this.id = id;
    this.projectName = projectName;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
    this.isIntegrationsActive = isIntegrationsActive;
    this.leadType = leadType;
    this.pipelineId = pipelineId;
    this.statusId = statusId;
    this.cityId = cityId;
    this.entityId = entityId;
    this.tag = tag;
    this.utmSource = utmSource;
    this.isExportToTzActive = isExportToTzActive;
    this.firstComment = firstComment;
    this.secondComment = secondComment;
    this.depth = depth;
    this.triggersMinCount = triggersMinCount;
    this.minAge = minAge;
    this.maxAge = maxAge;
    this.limits = limits;
    this.alphaNames = alphaNames;
    this.domainsList = domainsList;
    this.phones = phones;
    this.autoType = autoType;
    this.jkId = jkId;
    this.geoRegion = geoRegion;
  }

  public Id = (): string => {
    return this.id;
  };
  public ProjectName = (): string => {
    return this.projectName;
  };
  public CreatedAt = (): Date => {
    return this.createdAt;
  };
  public ModifiedAt = (): Date => {
    return this.modifiedAt;
  };
  public IsIntegrationsActive = (): boolean => {
    return this.isIntegrationsActive;
  };
  public LeadType = (): string => {
    return this.leadType;
  };
  public PipelineId = (): number => {
    return this.pipelineId;
  };
  public StatusId = (): number => {
    return this.statusId;
  };
  public CityId = (): number => {
    return this.cityId;
  };
  public HomeId = (): number => {
    return this.jkId;
  };
  public EntityId = (): number => {
    return this.entityId;
  };
  public Tag = (): string => {
    return this.tag;
  };
  public UtmSource = (): string => {
    return this.utmSource;
  };
  public AvtoType = (): number => {
    return this.autoType;
  };
  public IsExportToTzActive = (): boolean => {
    return this.isExportToTzActive;
  };
  public FirstComment = (): string => {
    return this.firstComment;
  };
  public SecondComment = (): string => {
    return this.secondComment;
  };
  public Depth = (): number => {
    return this.depth;
  };
  public TriggersMinCount = (): number => {
    return this.triggersMinCount;
  };
  public MinAge = (): number => {
    return this.minAge;
  };
  public MaxAge = (): number => {
    return this.maxAge;
  };
  public Limits = (): number => {
    return this.limits;
  };

  public LeadsCount = (): number | undefined => {
    return this.leadsCount;
  };

  public SetLeadsCount = (leadsCount: number) => {
    this.leadsCount = leadsCount;
  };

  public AlphaNames = (): string[] => {
    return this.alphaNames;
  };

  public Domains = (): string[] => {
    return this.domainsList;
  };

  public Phones = (): string[] => {
    return this.phones;
  };

  public GeoRegion = (): string[] => {
    return this.geoRegion;
  };

}
